// eslint-disable-next-line import/prefer-default-export
export const UNAUTHORISED_DS_API = 'UNAUTHORISED_DS_API';
